import React from 'react';
import styled from '@emotion/styled';
import { useSelector } from 'react-redux';

import LoginFormSSO from './LoginFormSSO';
import Logo from '../../../../../shared/images/full-logo-black-orange.png';
import PasswordNeeded from '../../shared/PasswordNeeded';
import SubText from '../../../../../shared/_TBComponents/SubText';

const FormArea = styled('div')`
  padding: 30px 54px;
  display: flex;
  flex-direction: column;
  position: relative;

  @media screen and (max-width: 600px) {
    padding: 30px;
  }
`;

const FormContainer = styled('div')`
  width: 430px;
  height: auto;
  background-color: white;
  padding-bottom: 40px;

  @media screen and (max-width: 600px) {
    width: 330px;
    height: auto;
    padding-bottom: 20px;
  }
`;

const TitleArea = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-bottom: 2px solid rgb(232, 232, 232);
  height: 160px;
  align-items: center;
  padding: 30px 80px 5px 80px;
  justify-content: center;

  img {
    margin-bottom: 20px;
  }

  @media screen and (max-width: 600px) {
    height: 135px;
  }
`;

const LoginFormContainerSSO = () => {
  const emailAddress = useSelector((state) => state.auth.data.emailAddress);
  const isPasswordNeeded = useSelector((state) => state.auth.data.isPasswordNeeded);

  if (isPasswordNeeded) {
    return <PasswordNeeded emailAddress={emailAddress} />;
  }
  return (
    <FormContainer>
      <TitleArea>
        <img alt='Teambuildr' className='img-fluid' src={Logo} />
        <SubText>Sign In</SubText>
      </TitleArea>
      <FormArea>
        <LoginFormSSO />
      </FormArea>
    </FormContainer>
  );
};

export default LoginFormContainerSSO;
